// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  destSid: __t.u64(),
  itemIds: __t.array(__t.u64()),
  stackId: __t.u64(),
  stackQty: __t.u32(),
  reward: __t.i64(),
  collateral: __t.i64(),
  recipientUsername: __t.string(),
  hours: __t.u32(),
  note: __t.string(),
};
